<template>
  <!--
        作者：gmshop
        时间：2020-06-08
        描述：超链接选择-云仓
    -->
    <el-select v-model="activePage" placeholder="请选择" class="percent-w100" @change="changeFunc" value-key="url">
        <el-option v-for="item in pages" :key="item.url" :value-key="item.name" :label="item.name" :value="item"></el-option>
    </el-select>
</template>

<script>
    export default{
        data(){
            return {
                /*云仓数据*/
                pages: [
                    {
                        url: 'pages/warehouse/warehouse',
                        name: '我的云仓',
                        type: '云仓'
                    },
                    {
                        url: 'pages/warehouse/record',
                        name: '出入云仓记录',
                        type: '云仓'
                    },
                    
                ],
                /*选中的值*/
                activePage: '我的云仓'
            }
        },
        created() {
          /*初始化*/
          this.changeFunc(this.pages[0]);
        },
        methods: {
            /*选中的值*/
            changeFunc(e){
                this.$emit('changeData', e);
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/setlink/part/warehouse.vue